module.exports = __webpack_public_path__ + "media/images/icon/icons8-Comments-b1e0580a3654dcbb03d9266e0ff90946.png";